import React from 'react';
import ExportIcon from '@atlaskit/icon/glyph/export';
import { useCreditNotePoller } from '@css-xp/ppc-refund-table';
import { DarkLoadingButton } from '@css-xp/ppc-dark-button';

export enum SIDEBAR {
  EDIT_SOLD_TO_ADDRESS = 'editSoldToAddress',
}

export const RefundDetailsPageActions = ({
  creditNoteId,
  transactionAccountId,
}: {
  creditNoteId: string;
  transactionAccountId: string;
}) => {
  const { handleCreditNoteDownload, isDownloadingPdf } = useCreditNotePoller(creditNoteId, transactionAccountId);
  return (
    <DarkLoadingButton
      appearance="primary"
      onClick={() => {
        handleCreditNoteDownload(creditNoteId);
      }}
      testId="export-invoices-as-csv"
      isLoading={isDownloadingPdf}
      iconBefore={<ExportIcon label="Export icon" size="small" />}
    >
      Export as PDF
    </DarkLoadingButton>
  );
};
